import { Component, ChangeDetectionStrategy } from '@angular/core';

import { DialogBodyComponent, DialogComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-empty-dialog',
  template: ` <rt-dialog-body>Empty Dialog</rt-dialog-body> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogBodyComponent],
})
export class EmptyDialogComponent extends DialogComponent<void> {}
